import React from 'react';
import LibDiv100vh from 'react-div-100vh';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
var useStyles = makeStyles(function () { return ({
    root: {},
}); });
export var Div100vh = function (props) {
    var classesProp = props.classes, classNameProp = props.className, style = props.style, children = props.children;
    var classes = useStyles({ classes: classesProp });
    var rootClassName = classNames(classes.root, classNameProp);
    return (React.createElement(LibDiv100vh, { className: rootClassName, style: style }, children));
};
